import BlueButton from '../../components/blue-button';
import {useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {toggleActionModal} from '../../../reducers/modals-action/actions';
import {closePromotionModal, clickPromotionModal} from '../../../utils/promotions';
import {redeemBoostBonus} from '../../../reducers/notifications/actions';
import ModalsLib from '../../../lib/modals';

export default ({index, details}) => {
    const dispatch = useDispatch();

    // Refs
    const overlay = useRef(),
          modal = useRef();

    const closeAction = (trigger, callback) => {
        if(modal.current) {
            modal.current.classList.remove('animate__slideInUp');
            modal.current.classList.add('animate__slideOutDown');
        }

        if(overlay.current) {
            overlay.current.classList.remove('animate__fadeIn');
            overlay.current.classList.add('animate__fadeOut');
        }

        setTimeout(() => {
            dispatch(toggleActionModal(details));
            
            if(trigger === 'close')
                closePromotionModal('notifications-deposit-boost');
            else
                clickPromotionModal('notifications-deposit-boost', callback);
        }, 500);
    }
    
    return (
        <div className="action-modal-fix social-affiliate">
            <div style={{zIndex: 400 + index}} className="action-modal-overlay animate__animated animate__fadeIn animate__faster" ref={overlay}></div>
            <div style={{zIndex: 400 + index}} className="action-modal-container">
                <div className="action-modal animate__animated animate__slideInUp animate__faster" ref={modal}>
                    <div className="notification-bonus-modal deposit-boost-modal">
                        <div className="notification-bonus-modal-close"  onClick={e => {
                            closeAction('close', () => {
                                
                            });
                        }}>
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="40" height="40" rx="7" fill="#211D2A"/>
                                <path d="M14 26L26 14" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M26 26L14 14" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <div className="notification-bonus-modal-wrapper">
                            <div className="notification-bonus-modal-container">
                                <div className="notification-bonus-modal-line"></div>
                                <div className="notification-bonus-modal-image">
                                    <img src={`${window.location.origin}/source/system/modals-action/notifications-bonuses/deposit-boost.png`} />
                                </div>
                                <div className="notification-bonus-modal-details">
                                    <div className="notification-bonus-modal-details-title" dangerouslySetInnerHTML={{__html: details.title}}></div>
                                    <div className="notification-bonus-modal-details-text"  dangerouslySetInnerHTML={{__html: details.text}}></div>
                                </div>
                                <div className="notification-bonus-modal-buttons">
                                    <BlueButton  onClick={e => {
                                        closeAction('click', () => {
                                            dispatch(redeemBoostBonus(details.notification_id));
                                        });
                                    }}>Activate boost</BlueButton>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
        </div>
    )
}